module.exports = __webpack_public_path__ + "static/media/loading.6db7bdd1.gif";